/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import './ActivitySummaryCommentary.scss';

import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { ruleLookupIndexByValuesAS } from '../../../services/Commentary';
import { interpolate } from '../../../services/Template';
import CommentaryActivity from '../../shared/Commentary/CommentaryActivity';
import { activitySummaryCommentaryEnabled } from 'services/FeatureFlags';

class ActivitySummaryCommentary extends React.Component {
  render() {
    const { commentary = {}, summary } = this.props;

    let lookupIndex = ruleLookupIndexByValuesAS(
      summary.income,
      summary.additions,
      summary.deductions,
      summary.marketFluctuation,
      summary.beginningMarketValue,
      summary.endingMarketValue
    );

    let asCommentary = [];
    let lookupResult = commentary.rulesToTemplateLookup[lookupIndex];
    let changeValue = summary.endingMarketValue - summary.beginningMarketValue;
    if (lookupResult && lookupResult.templateIds) {
      let templateIds = lookupResult.templateIds;

      const templateParams = {
        ...summary,
        changeValue
      };

      asCommentary = templateIds.map((tmpId) => {
        let template = commentary.templates.find(
          (tmp) => tmp.id === tmpId
        ).template;
        return interpolate(template, templateParams);
      });
    }

    if (isEmpty(asCommentary) || !activitySummaryCommentaryEnabled()) {
      asCommentary = ['No observations available.'];
    }

    return (
      <div id="activity-summary-commentary">
        <CommentaryActivity
          commentary={asCommentary}
          changeValue={changeValue}
        />
      </div>
    );
  }
}

ActivitySummaryCommentary.propTypes = {
  summary: PropTypes.object,
  commentary: PropTypes.object
};

export default ActivitySummaryCommentary;
